import { io, Socket } from "socket.io-client";
import { queryClient } from "./queryClient";
import { getApiBase } from "./api";

let socket: Socket | null = null;

export function connectSocket(userId: string) {
  if (socket?.connected) return;

  const base = getApiBase();
  socket = io(base.length > 0 ? base : window.location.origin, {
    path: "/ws",
    auth: { userId },
    transports: ["websocket", "polling"],
    withCredentials: true,
  });

  socket.on("data-changed", (payload: { queryKeys: string[] }) => {
    for (const key of payload.queryKeys) {
      queryClient.invalidateQueries({ queryKey: [key] });
    }
  });

  socket.on("connect", () => {
    console.log("[socket] connected");
  });

  socket.on("disconnect", () => {
    console.log("[socket] disconnected");
  });
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
